import { useMutation } from "react-query";
import { reactQueryPost } from "@/react/helpers/backendRequestHelpers";
import { internalApi } from "@/react/helpers/urlHelpers";

interface CreateAttachmentOptions {
  conversationId?: string | number;
  onError?: (error: unknown) => void;
  onSuccess?: (data: { zendesk_upload_id: string }) => void;
}

interface CreateAttachmentParams {
  filename: string;
  signedId: string;
  url: string;
}

export const useCreateAttachment = ({
  onSuccess,
  onError,
  conversationId,
}: CreateAttachmentOptions = {}) =>
  useMutation({
    mutationFn: async ({ filename, signedId, url }: CreateAttachmentParams) =>
      reactQueryPost(
        internalApi.helpWidget.createAttachment({ conversationId }),
        {
          signed_id: signedId,
          filename,
          url,
          completed: true,
        },
      ),
    onSuccess,
    onError,
  });
